import { takeEvery } from 'redux-saga/effects';

import fetchData from '../../../api/fetchData';

import { FETCH_PACKAGE_URL } from '../../actions/general';
import { safeCall, safeApply } from '../errors';

function* openPackageUrl({ payload }) {
  const { value: id } = payload;
  const apiUrl = `${process.env.API_HOST_URL}${process.env.API_PACKAGE_URL}`;

  const { url } = yield safeCall(fetchData, apiUrl, {
    method: 'POST',
    body: JSON.stringify({ package_id: id }),
    headers: { 'Content-Type': 'application/json' },
  });

  if (url) {
    window.open(url, '_blank');
  }
}

export default function* () {
  yield takeEvery(FETCH_PACKAGE_URL, safeApply(openPackageUrl));
}
